import Reducers from "./index";
import { combineReducers } from "redux";

const rootReducers = combineReducers({
  Reducers,
});
export default rootReducers;
